import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DateTime from 'react-datetime';

import './DatePicker.css';

const formatValue = (value) => {
  return value ? moment(value).format('MM/DD/YYYY') : '';
};

class DatePicker extends React.Component {
  openCalendar() {
    this.refs.datePicker.openCalendar();
  }
  handleChange = (newValue) => {
    this.props.onChange(newValue.toISOString());
  };

  checkDateIsValid = (current) => {
    const today = moment();
    return current.isBefore(today);
  };

  render() {
    const {
      tabIndex,
      value,
      noToday,
      id,
      ariaDescribedBy,
      ariaInvalid,
    } = this.props;
    return (
      <div className="date-picker__container">
        <DateTime
          timeFormat={false}
          closeOnSelect
          ref="datePicker"
          isValidDate={this.checkDateIsValid}
          inputProps={{
            readOnly: true,
            className: 'date-picker__input form-control',
            value: formatValue(value, noToday),
            tabIndex,
            ...(id ? { id } : {}),
            ...(ariaDescribedBy ? { 'aria-describedby': ariaDescribedBy } : {}),
            ...(ariaInvalid === true || ariaInvalid === false
              ? { 'aria-invalid': ariaInvalid }
              : {}),
          }}
          value={moment(value)}
          onChange={this.handleChange}
        />
        <div
          className="date-picker__icon-hook"
          onClick={() => {
            this.openCalendar();
          }}
        />
      </div>
    );
  }
}
DatePicker.propTypes = {
  tabIndex: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  noToday: PropTypes.bool,
  id: PropTypes.string,
  ariaDescribedBy: PropTypes.string,
  ariaInvalid: PropTypes.bool,
};
DatePicker.defaultProps = {
  isValidDate: () => true,
  timezone: null,
};

export const makeDatePicker = ({
   
  input,
  ...options
   
}) => (
  <DatePicker
    {...input}
    {...options}
  />
);

export default DatePicker;
